__turbopack_context__.v({
  "browseBy": "MakeReviews-module__d1A31G__browseBy",
  "cards": "MakeReviews-module__d1A31G__cards",
  "chipFilters": "MakeReviews-module__d1A31G__chipFilters",
  "makeTiles": "MakeReviews-module__d1A31G__makeTiles",
  "reviews": "MakeReviews-module__d1A31G__reviews",
});
